import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const euSignSettingsService = { getCasJson, getCasCertificates };

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'eusign-settings'
};

async function getCasJson() {
  return axios.get(`${model.baseUrl}${model.controller}/cas`);
}

async function getCasCertificates() {
  return axios.get(`${model.baseUrl}${model.controller}/cas-certificates`, { responseType: 'blob' });
}
